import produce from 'immer';
import {
  GET_AUDIT_LOGS_START,
  GET_AUDIT_LOGS_SUCCESS,
  GET_AUDIT_LOGS_FAILED,
  GET_AUDIT_LOGS_EXPORT_START,
  GET_AUDIT_LOGS_EXPORT_SUCCESS,
  GET_AUDIT_LOGS_EXPORT_FAILED,
} from '../actions/audit_logs';


const initialState = {
  auditLogs: {},
  loadingAuditLogs: false
};

const formReducer = produce((state = initialState, action) => {
  switch (action.type) {
    case GET_AUDIT_LOGS_START: {
      state.loadingAuditLogs = true;
      break;
    }
    case GET_AUDIT_LOGS_SUCCESS: {
      const {data} = action;

      state.auditLogs = data;
      state.loadingAuditLogs = false;

      break;
    }
    case GET_AUDIT_LOGS_FAILED: {
      state.loadingAuditLogs = false;
      break;
    }
    case GET_AUDIT_LOGS_EXPORT_START: {
      state.loadingAuditLogs = true;
      break;
    }
    case GET_AUDIT_LOGS_EXPORT_SUCCESS: {
      state.loadingAuditLogs = false;
      break;
    }
    case GET_AUDIT_LOGS_EXPORT_FAILED: {
      state.loadingAuditLogs = false;
      break;
    }
    default:
      break;
  }
}, initialState);

export default formReducer;
